import { render, staticRenderFns } from "./Authentication-modal.vue?vue&type=template&id=dd548252&scoped=true&"
import script from "./Authentication-modal.vue?vue&type=script&lang=js&"
export * from "./Authentication-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd548252",
  null
  
)

export default component.exports